export const SHOPIMIND_SHA1_SALT = 'unpetitgraindefolie-';

export const SHOPIMIND_SHA1_SALT_ELEMENTS = '4d6c!dpjbYepLoXHmCHK_';

// Infobip SMS API authentication keys
export const INFOBIP_AUTH_KEY_MARKETING = btoa('SHOPIMIND1:SPMmi,2014');
export const INFOBIP_AUTH_KEY_TRANSACTIONAL = btoa('SHOPIMIND2:S250904d');

export const SHORT_URL_DOMAIN = 's6m.me';

export const SUPPORT_SHOPIMIND_EMAIL = 'support@shopimind.com';
